import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import GlobalFeedback from "./components/GlobalFeedback";
import Home from "./pages/Home";
import ReviewerAssigner from "./pages/ReviewerAssigner";
import DataOperatorUpload from "./pages/DataOperatorUpload";
import Review from "./pages/Review";
import UploadQuestionPapers from "./pages/UploadQuestionPapers";
import AnalyzeQuestionPapers from "./pages/AnalyzeQuestionPapers";
import RubricManagement from './pages/RubricManagement';
import AnalyticsDashboard from "./pages/AnalyticsDashboard";
import "./styles/App.css";
import ProtectedRoute from './middlewares/routeprotection';
import { CAPABILITIES } from './config/roles';

function App() {
  return (
    <div className="app">
      <Header />
      <main className="main-content">
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />

          {/* Protected */}
          <Route
            path="/assigner_page"
            element={
              <ProtectedRoute allowedRoles={CAPABILITIES.reviewerAssigner}>
                <ReviewerAssigner />
              </ProtectedRoute>
            }
          />

          <Route
            path="/data_operator_upload"
            element={
              <ProtectedRoute allowedRoles={CAPABILITIES.csvUpload}>
                <DataOperatorUpload />
              </ProtectedRoute>
            }
          />

          <Route
            path="/review_page"
            element={
              <ProtectedRoute allowedRoles={CAPABILITIES.review}>
                <Review />
              </ProtectedRoute>
            }
          />

          <Route
            path="/upload_page"
            element={
              <ProtectedRoute allowedRoles={CAPABILITIES.uploadPapers}>
                <UploadQuestionPapers />
              </ProtectedRoute>
            }
          />

          {/* Automated Evaluation is a tab of Upload Question Papers now. The
              path is kept as a redirect so an old bookmark or a pasted link
              still lands somewhere useful instead of on a blank page. It needs
              no guard of its own - /upload_page carries one. */}
          <Route
            path="/automated_evaluation"
            element={<Navigate to="/upload_page" replace />}
          />

          <Route
            path="/analyze_page"
            element={
              <ProtectedRoute allowedRoles={CAPABILITIES.analyzePapers}>
                <AnalyzeQuestionPapers />
              </ProtectedRoute>
            }
          />

          <Route
            path="/analytics"
            element={
              <ProtectedRoute allowedRoles={CAPABILITIES.analytics}>
                <AnalyticsDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/rubric_management"
            element={
              <ProtectedRoute allowedRoles={CAPABILITIES.rubricManagement}>
                <RubricManagement />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      <Footer />
      <GlobalFeedback />
    </div>
  );
}

export default App;
